import type { VariablesOf } from 'relay-runtime';

import { createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';
import { tqlQueryFromInput } from '@townsquare/tql/query';
import { ComparatorOperator } from '@townsquare/tql/types';

import ProjectSettingsViewQuery, {
	ProjectSettingsViewQuery as ProjectSettingsViewQueryType,
} from '../components/ProjectSettings/__generated__/ProjectSettingsViewQuery.graphql';

export const projectSettingsPageResource = createRelayResource<ProjectSettingsViewQueryType>({
	getQuery: (_routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		const fieldListTql = tqlQueryFromInput({
			input: [
				{
					fieldName: 'entityType',
					comparator: ComparatorOperator.EQUALS,
					fieldValue: 'PROJECT',
				},
			],
		});
		const variables: VariablesOf<ProjectSettingsViewQueryType> = {
			workspaceUuid: context.workspace?.UUID ?? '',
			tql: fieldListTql,
		};

		return {
			query: ProjectSettingsViewQuery,
			variables,
		};
	},
});
